import { createContext, useContext, type ReactNode } from 'react'
import { useBlogMetadata } from '@/hooks/useBlogMetadata'
import type { BlogCategory, BlogTag } from '@/services/blogMetadataCache'

interface BlogMetadataContextValue {
  categories: BlogCategory[]
  tags: BlogTag[]
  loading: boolean
  error: Error | null
  refresh: () => Promise<void>
  invalidateCategories: () => void
  invalidateTags: () => void
  invalidateAll: () => void
}

const BlogMetadataContext = createContext<BlogMetadataContextValue | undefined>(undefined)

interface BlogMetadataProviderProps {
  children: ReactNode
}

export function BlogMetadataProvider({ children }: BlogMetadataProviderProps) {
  const metadata = useBlogMetadata()

  return (
    <BlogMetadataContext.Provider value={metadata}>
      {children}
    </BlogMetadataContext.Provider>
  )
}

export function useBlogMetadataContext(): BlogMetadataContextValue {
  const context = useContext(BlogMetadataContext)
  if (context === undefined) {
    throw new Error('useBlogMetadataContext must be used within a BlogMetadataProvider')
  }
  return context
}